/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Backstage_Queue_ProposalsInputs */

const en_scene_backstage_queue_proposals = /** @type {(inputs: Scene_Backstage_Queue_ProposalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proposals from suppliers`)
};

/**
* | output |
* | --- |
* | "Proposals from suppliers" |
*
* @param {Scene_Backstage_Queue_ProposalsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const scene_backstage_queue_proposals = /** @type {((inputs?: Scene_Backstage_Queue_ProposalsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Backstage_Queue_ProposalsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_scene_backstage_queue_proposals(inputs)
});